import { useNavigate } from "react-router-dom";
import moment from "moment";

import { IColumnProps } from "../../../interfaces/tables";
import { IResourceListItem } from "../../../interfaces/resources";

import { SVGIcon } from "../../wrappers/SVGIcon";

import { Icons } from "../../../data/Assets";

interface ResourcesListTableProps {
    resources: IResourceListItem[];
    isLoading: boolean;
};
export const ResourcesListTable = (props: ResourcesListTableProps) => {
    const { resources, isLoading } = props;

    const navigate = useNavigate();

    const columns: IColumnProps[] = [
        { name: "Category", identifier: "category" },
        { name: "Title", identifier: "title" },
        { name: "Thumbnail", identifier: "thumbnail" },
        { name: "URL", identifier: "url" },
        { name: "Created At", identifier: "created_at" },
    ];

    return (
        <div className="immersion__list_table__container">
            <table className="immersion__list_table">
                <thead>
                    <tr>
                        {columns.map(column =>
                            <th key={column.identifier}>
                                <div className='display_flex'>
                                    <button className={`${column.buttonClass ?? ''}`}>
                                        {column.name}
                                        {column?.sort && <SVGIcon src={Icons.ArrowDownUp} color='primary' />}
                                    </button>
                                </div>
                            </th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {isLoading &&
                        <tr>
                            <td colSpan={columns.length}>
                                <div className="display_flex flex_dir_column display_flex_center">
                                    <span className="wt_600 pb_10">Loading</span>
                                    <i className='immersion__list_loader' />
                                </div>
                            </td>
                        </tr>
                    }
                    {!isLoading && !resources.length &&
                        <tr>
                            <td colSpan={columns.length} className='text_center'>
                                No records found.
                            </td>
                        </tr>
                    }
                    {
                        !isLoading && !!resources.length &&
                        resources.map((item) => {
                            return (
                                <tr
                                    key={item.id}
                                    onClick={() => navigate(`/resources/details/${item.id}`)}
                                >
                                    <td>{item.category.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</td>
                                    <td>{item.title}</td>
                                    <td>
                                        {item.thumbnail_url
                                            ? <a style={{ display: 'inline', textDecoration: 'underline' }} href={item.thumbnail_url} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>
                                                View Thumbnail
                                            </a>
                                            : "-"
                                        }
                                    </td>
                                    <td>
                                        {item.url
                                            ? <a style={{ display: 'inline', textDecoration: 'underline' }} href={item.url} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>
                                                View Resource
                                            </a>
                                            : "-"
                                        }
                                    </td>
                                    <td>{moment(item.created_at).format('MMM DD, YYYY')}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};